import type {
  Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import {
  type ApiClientRouteCreateMutation,
  type ApiClientQuery,
  type ApiClientRouteDeleteMutation,
  ApiClientDocument,
  type ApiClientRouteDeleteMutationVariables
} from '@/graphql/generated/graphql';

const apiClientRoutes: UpdatesConfig['Mutation'] = {
  apiClientRouteCreate: (data: ApiClientRouteCreateMutation, __: Variables, cache: Cache) => {
    const apiClientID = data.apiClientRouteCreate?.api_client_id as number;
    cache.updateQuery<ApiClientQuery>({
      query: ApiClientDocument,
      variables: { id: apiClientID },
    }, (apiClient) => {
      if (!apiClient || !apiClient.apiClient) {
        return apiClient;
      }
      apiClient.apiClient.routes.push(data?.apiClientRouteCreate?.route);
      return apiClient;
    });
  },
  apiClientRouteDelete: (data: ApiClientRouteDeleteMutation, vars: ApiClientRouteDeleteMutationVariables, cache: Cache) => {
    const apiClientID = data.apiClientRouteDelete?.api_client_id as number;
    cache.updateQuery<ApiClientQuery>({
      query: ApiClientDocument,
      variables: { id: apiClientID },
    }, (apiClient) => {
      if (!apiClient || !apiClient.apiClient) {
        return apiClient;
      }
      const routes = apiClient.apiClient.routes.filter(
        (route) => route?.id !== data.apiClientRouteDelete?.id,
      );

      apiClient.apiClient.routes = routes;
      return apiClient;
    });
  },
};

export default apiClientRoutes;
